/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A single piece of match evidence
 * @export
 * @interface EvidenceItem
 */
export interface EvidenceItem {
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    content?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof EvidenceItem
     */
    uploadedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof EvidenceItem
     */
    uploadedAt?: number;
}

/**
 * Check if a given object implements the EvidenceItem interface.
 */
export function instanceOfEvidenceItem(value: object): value is EvidenceItem {
    return true;
}

export function EvidenceItemFromJSON(json: any): EvidenceItem {
    return EvidenceItemFromJSONTyped(json, false);
}

export function EvidenceItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceItem {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'url': json['url'] == null ? undefined : json['url'],
        'content': json['content'] == null ? undefined : json['content'],
        'description': json['description'] == null ? undefined : json['description'],
        'uploadedBy': json['uploadedBy'] == null ? undefined : json['uploadedBy'],
        'uploadedAt': json['uploadedAt'] == null ? undefined : json['uploadedAt'],
    };
}

export function EvidenceItemToJSON(json: any): EvidenceItem {
    return EvidenceItemToJSONTyped(json, false);
}

export function EvidenceItemToJSONTyped(value?: EvidenceItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'url': value['url'],
        'content': value['content'],
        'description': value['description'],
        'uploadedBy': value['uploadedBy'],
        'uploadedAt': value['uploadedAt'],
    };
}

